import { IStreamState } from "./reducer";

const initialState: IStreamState = {
  isFetchingAll: false,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
  isArchiving: false,
  isRestoring: false,
  isComputing: false,
  isFetchingJobHistory: false,
  isRunning: false,
  selectedStream: null,
  streams: [],
  errors: [],
};

export default initialState;
